import { Plus, LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  searchQuery?: string;
  noSearchResultsTitle?: string;
  noSearchResultsDescription?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  searchQuery,
  noSearchResultsTitle,
  noSearchResultsDescription
}: EmptyStateProps) {
  const isSearching = Boolean(searchQuery);
  const displayTitle = isSearching ? noSearchResultsTitle || "No results found" : title;
  const displayDescription = isSearching
    ? noSearchResultsDescription ||
      "Try adjusting your search terms to find what you're looking for"
    : description;

  return (
    <div className="py-16">
      <div className="mx-auto flex max-w-lg flex-col items-center gap-4 rounded-lg border border-dashed border-border bg-card px-6 py-14 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-accent text-accent-foreground">
          <Icon className="h-6 w-6" />
        </span>
        <div className="space-y-1.5">
          <h3 className="text-base font-semibold">{displayTitle}</h3>
          <p className="mx-auto max-w-sm text-sm leading-relaxed text-muted-foreground">
            {displayDescription}
          </p>
        </div>
        {!isSearching && actionLabel && onAction && (
          <Button onClick={onAction} className="mt-1">
            <Plus className="h-4 w-4" />
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
